import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function CheckListList() {
  return <List />
}

export default hipladeTemplate(CheckListList)
